
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactDataSheet from 'react-datasheet'
import 'react-datasheet/lib/react-datasheet.css'
import { useHistory } from 'react-router-dom'

import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Dialog } from 'primereact/dialog'


import back from '../assets/images/back.svg'
import { uuidv4 } from '../_common/utils'
import { authConstants } from '../_constants'
import { companyValidation } from '../_validation'
const adjustmentCount = 5
const SheetRenderer = props => {
  const { as: Tag, headerAs: Header, bodyAs: Body, rowAs: Row, cellAs: Cell,
    className, columns, selections, onSelectAllChanged, gridSelections } = props
  return (
    <Tag className={className}>
      <Header className='data-header'>
        <Row>
          <Cell className='action-cell cell'>SELECT
            <input
              type='checkbox'
              checked={selections.every(s => s) || gridSelections.every(s => s)}
              onChange={e => onSelectAllChanged(e.target.checked)}
            />
          </Cell>
          {columns.map(column => <Cell className='cell' style={{ width: column.width }} key={column.label}>{column.label}</Cell>)}
        </Row>
      </Header>
      <Body className='data-body'>
        {props.children}
      </Body>
    </Tag>
  )
}

const RowRenderer = props => {
  const { as: Tag, cellAs: Cell, className, row, selected, onSelectChanged, uniqueId } = props
  
  return (
    <Tag className={className}>
      <Cell className='action-cell cell'>
        <div className="serial-number">{parseInt(uniqueId - adjustmentCount < 0 ? 0 : uniqueId - adjustmentCount) + row + 1}</div>
        <input id={"chk"+(parseInt(uniqueId - adjustmentCount < 0 ? 0 : uniqueId - adjustmentCount) + row + 1).toString()}
          type='checkbox'
          checked={selected}
          onChange={e => onSelectChanged(row, e.target.checked)}
        />
      </Cell>
      {props.children}
    </Tag>
  )
}

const CellRenderer = props => {
  const {
    as: Tag, cell, row, col, columns, attributesRenderer,
    selected, editing, updated, style,
    ...rest
  } = props

  // hey, how about some custom attributes on our cell?
  const attributes = cell.attributes || {}
  // ignore default style handed to us by the component and roll our own
  attributes.style = { width: columns[col].width }
  if (col === 0) {
    //attributes.title = cell.label
  }
  if (col === 5) {
    attributes.type = 'number'
  }
  if (col === 0) {
    attributes.type = 'companyName'
  }
  if (col === 2 || col === 3 || col === 4) {
    attributes.type = 'material'
  }
  return (
    <Tag {...rest} {...attributes}>
      {props.children}
    </Tag>
  )
}
function BulkCopyComponent({ bulkUpdatResponse, bulkAddForCopyPaste }) {
  const [showResult, setShowResult] = useState(false)
  const history = useHistory()
  const currentUserId = localStorage.getItem(authConstants.USERID)
  const [isDialogVisible, setIsDialogVisible] = useState(false)
  const [uploadDataReponse, setUploadDataResponse] = useState({ saved: 0, failed: 0, updated: 0, duplicate: 0 })
  const [isEmptyDialogVisible, setIsEmptyDialogVisible] = useState(false)
  const [showLoader, setshowLoader] = useState(false)
  const numberOfRows = 20;
  const maxNumRows = 50;
  const getEmptyArray = () => {
    const emptyObjectArray = []
    for (let i = 0; i < gridColumns.length; i++) {
      emptyObjectArray.push({ value: '', attributes: {}, column: gridColumns[i] })
    }
    return emptyObjectArray
  }
  let selections = []
  const emptyData = (diffRows) => {
    const emptyDataArray = []
    selections = []
    for (let i = 0; i < numberOfRows - diffRows; i++) {
      emptyDataArray.push(getEmptyArray())
      selections.push(false)
    }
    return emptyDataArray
  }
  const getSelections = (diffRows) => {
    const selections = []
    for (let i = 0; i < numberOfRows - diffRows; i++) {
      selections.push(false)
    }
    return selections
  }
  const getSelectionsSpecific = (selected,rowCount) => {
    const selections = []
    for (let i = 0; i < rowCount; i++) {
      selections.push(selected)
    }
    return selections
  }
  const getErrorAttributes = (value, colName) => {
    const result = companyValidation.emptyAndLengthValidate(value, colName)
    return { 'error': result ? 'yes' : 'no', title: result }
  }
  const getLengthErrorAttributes = (value, length) => {
    const result = companyValidation.maxLengthValidate(value, length)
    return { 'error': result ? 'yes' : 'no', title: result }
  }
  const getMapKeyErrorAttributes = (value, name) => {
    const result = companyValidation.validateMapKeys(value, name)
    return { 'error': result ? 'yes' : 'no', title: result }
  }
  useEffect(() => {
    setshowLoader(false)
    if (bulkUpdatResponse) {

      const uploadReponse = { saved: 0, failed: 0, updated: 0, duplicate: 0 }
      uploadReponse.saved = (Object.keys(bulkUpdatResponse['SAVED']))
      uploadReponse.failed = (Object.keys(bulkUpdatResponse['FAILED']))
      uploadReponse.duplicate = (Object.keys(bulkUpdatResponse['DUPLICATE']))
      uploadReponse.updated = (Object.keys(bulkUpdatResponse['UPDATED']))
      setUploadDataResponse(uploadReponse)
      if (uploadReponse.failed > 0) {
        const failedList = bulkUpdatResponse['FAILED'][Object.keys(bulkUpdatResponse['FAILED'])[0]]
        let failedRows = []
        let selections = []
        let gridSelections = []
        for (let i = 0; i < failedList.length; i++) {
          const data = failedList[i]
          const dataArray = [
            { value: data.name ? data.name : '', attributes: getErrorAttributes(data.name, 'Company Name') },
            { value: data.ticker ? data.ticker : '', attributes: getLengthErrorAttributes(data.ticker, 15) },
            { value: data.sectorName ? data.sectorName : '', attributes: getErrorAttributes(data.sectorName, 'Sector') },
            { value: data.industryName ? data.industryName : '', attributes: getErrorAttributes(data.industryName, 'Industry') },
            { value: data.exchangeName ? data.exchangeName : '', attributes: getLengthErrorAttributes(data.exchangeName, 256) },
            { value: data.marketCapitalization ? data.marketCapitalization : 0 },
            { value: data.exchangeCountry ? data.exchangeCountry : '', attributes: getLengthErrorAttributes(data.exchangeName, 312) },
            { value: data.earningsYeild ? data.earningsYeild : '', attributes: getLengthErrorAttributes(data.exchangeName, 312) },
            { value: data.barriers ? data.barriers : '', attributes: getMapKeyErrorAttributes(data.barriers, 'Barriers') },
            { value: data.financialStrength ? data.financialStrength : '', attributes: getMapKeyErrorAttributes(data.financialStrength, 'Financial Strength') },
            { value: data.momentum ? data.momentum : '', attributes: getMapKeyErrorAttributes(data.momentum, 'Momentum') },
            { value: data.growthType ? data.growthType : '', attributes: getMapKeyErrorAttributes(data.growthType, 'Growth Type') },
            { value: data.topNewsBuy ? data.topNewsBuy : '', attributes: getMapKeyErrorAttributes(data.topNewsBuy, 'TopNewsBuy') },
            { value: data.dividendLeader ? data.dividendLeader : '', attributes: getMapKeyErrorAttributes(data.dividendLeader, 'Dividend Leader') },
            { value: data.sociallyResponsible ? data.sociallyResponsible : '', attributes: getMapKeyErrorAttributes(data.sociallyResponsible, 'Socially Responsible') },
            { value: data.watchlist ? data.watchlist : '', attributes: getMapKeyErrorAttributes(data.watchlist, 'Watchlist') },
            { value: data.intersection ? data.intersection : '', attributes: getMapKeyErrorAttributes(data.intersection, 'Intersection') },
            { value: data.underValued ? data.underValued : '', attributes: getMapKeyErrorAttributes(data.underValued, 'UnderValued') }
          ]
          selections.push(false)
          failedRows.push(dataArray)
        }
        if (failedRows.length < numberOfRows) {
          failedRows = failedRows.concat(emptyData(failedRows.length))
          selections = selections.concat(getSelections(failedRows.length))
          gridSelections = gridSelections.concat(getSelections(failedRows.length))
          scrollTop()
        }
        setGridData({ ...gridData, allRows: failedRows, grid: failedRows, selections: selections, currentStart: 0, gridSelections })
      } else {
        setGridData({ ...gridData, allRows: emptyData(0), grid: emptyData(0), selections: getSelections(0), currentStart: 0, gridSelections: getSelections(0) })
      }
      setShowResult(true)
      setTimeout(function () { setShowResult(false) }, 60000)
    }

  }, [bulkUpdatResponse])

  const gridColumns = [
    { label: 'COMPANY NAME', width: '205px', },
    { label: 'TICKER', width: '100px' },
    { label: 'SECTOR', width: '155px' },
    { label: 'INDUSTRY', width: '150px' },
    { label: 'EXCHANGE', width: '150px' },
    { label: 'MARKET CAPITALIZATION (USD)', width: '100px' },
    { label: 'EXCHANGE COUNTRY', width: '100px' },
    { label: 'EARNINGS YIELD', width: '100px' },
    { label: 'BARRIERS', width: '100px' },
    { label: 'FINANCIAL STRENGTH', width: '100px' },
    { label: 'MOMENTUM', width: '100px' },
    { label: 'GROWTH TYPE', width: '100px' },
    { label: 'TOP NEW BUYS', width: '100px' },
    { label: 'DIVIDEND LEADER', width: '100px' },
    { label: 'SOCIALLY RESPONSIBLE', width: '100px' },
    { label: 'WATCH LIST', width: '100px' },
    { label: 'INTERSECTION', width: '100px' },
    { label: 'UNDERVALUED', width: '100px' }
  ]
  const [gridData, setGridData] = useState(
    {
      as: 'table',
      columns: gridColumns,
      grid: emptyData(0),
      selections: selections,
      allRows: emptyData(0),
      currentStart: 0,
      scrollTop: 0,
      gridSelections: getSelections(0)
    }
  )
  console.log(gridData)
  const handleSelectAllChanged = (selected) => {
    let selections = gridData.selections.map(s => selected)
    let gridSelections = gridData.gridSelections.map(g => selected)
    if(gridData.allRows.length>selections.length || gridData.grid.length>gridSelections.length){
      selections =selections.concat(getSelectionsSpecific(selected,gridData.allRows.length-selections.length))
      gridSelections =gridSelections.concat(getSelectionsSpecific(selected,gridData.grid.length-gridSelections.length))
    }
    setGridData({ ...gridData, selections, gridSelections })
  }

  const handleSelectChanged = (index, selected) => {
    const selections = [...gridData.gridSelections]
    let allSelections = [...gridData.selections]
    selections[index] = selected
    if (gridData.currentStart >= 20) {
      allSelections[gridData.currentStart - adjustmentCount + index] = selected
    } else {
      allSelections[index] = selected
    }
    setGridData({ ...gridData, gridSelections: selections, selections: allSelections })
  }

  const handleCellsChanged = (changes, additions) => {
    let grid = gridData.allRows.map(row => [...row])
    let selections = gridData.selections
    let gridSelections = gridData.gridSelections

    let adjustment=gridData.currentStart;
    if(grid.length>maxNumRows && gridData.currentStart>0)
      adjustment=gridData.currentStart - adjustmentCount
    changes.forEach(({ cell, row, col, value }) => {
      console.log(row)
      try{
      if (col === 1) {
        value = value.toString().toUpperCase()
        grid[row + adjustment][col] = { ...grid[row + adjustment][col], value }
      } else if (col === 5) {
        value = companyValidation.checkMarketCap(value.toString().replace(',', ''))
        grid[row + adjustment][col] = { ...grid[row + adjustment][col], value }
      } else {
        grid[row + adjustment][col] = { ...grid[row + adjustment][col], value }
      }
    }catch(e){
      console.log(e)
      console.log(row)
    }
    })
    // paste extended beyond end, so add a new row
    adjustment=gridData.currentStart;
    if(grid.length>maxNumRows && gridData.currentStart>0)
      adjustment=gridData.currentStart-adjustmentCount
    additions && additions.forEach(({ cell, row, col, value }) => {
      console.log(row)
      if (!grid[row + adjustment]) {
        grid[row + adjustment] = getEmptyArray()// [{value: ''}, {value: ''}, {value: ''}, {value: 0}]
        selections.push(false)
      }
      if (grid[row + adjustment][col]) {
        if (col === 1) {
          value = value.toString().toUpperCase()
          grid[row + adjustment][col] = { ...grid[row + adjustment][col], value }
        } else if (col === 5) {
          value = companyValidation.checkMarketCap(value.toString().replace(',', ''))
          grid[row + adjustment][col] = { ...grid[row + adjustment][col], value }
        } else {
          grid[row + adjustment][col] = { ...grid[row + adjustment][col], value }
        }
      }
    })
    let currentRows = grid
    if (grid.length > maxNumRows) {
      const remainder = grid.length % 20
      grid = grid.concat(emptyData(remainder))
      selections = selections.concat(getSelections(remainder))
      let start = (gridData.currentStart - adjustmentCount < 0) ? 0 : gridData.currentStart - adjustmentCount
      let end = gridData.currentStart + numberOfRows + adjustmentCount
      currentRows = grid.slice(start, end)
      gridSelections = selections.slice(start,end)
    }
    setGridData({ ...gridData, grid: currentRows, allRows: grid, selections, gridSelections })
    console.log('cell change event' + gridData.currentStart)
  }

  const sheetRenderer = (props) => {
    const { columns, gridSelections, selections } = gridData
    switch (gridData.as) {
      case 'list':
        return <SheetRenderer columns={columns} gridSelections={selections} selections={gridSelections} onSelectAllChanged={handleSelectAllChanged} as='segment' headerAs='div' bodyAs='ul' rowAs='div' cellAs='div' {...props} />
      case 'div':
        return <SheetRenderer columns={columns} gridSelections={selections} selections={selections} onSelectAllChanged={handleSelectAllChanged} as='div' headerAs='div' bodyAs='div' rowAs='div' cellAs='div' {...props} />
      default:
        return <SheetRenderer columns={columns} gridSelections={selections} selections={selections} onSelectAllChanged={handleSelectAllChanged} as='table' headerAs='thead' bodyAs='tbody' rowAs='tr' cellAs='th' {...props} />
    }
  }

  const rowRenderer = (props) => {
    const selections = gridData.gridSelections
    switch (gridData.as) {
      case 'list':
        return <RowRenderer as='li' cellAs='div' uniqueId={gridData.currentStart} selected={selections[props.row]} onSelectChanged={handleSelectChanged} className='data-row' {...props} />
      case 'div':
        return <RowRenderer as='div' cellAs='div' uniqueId={gridData.currentStart} selected={selections[props.row]} onSelectChanged={handleSelectChanged} className='data-row' {...props} />
      default:
        return <RowRenderer as='tr' cellAs='td' uniqueId={gridData.currentStart} selected={selections[props.row]} onSelectChanged={handleSelectChanged} className='data-row' {...props} />
    }
  }

  const cellRenderer = (props) => {
    switch (gridData.as) {
      case 'list':
        return <CellRenderer as='div' columns={gridData.columns} {...props} />
      case 'div':
        return <CellRenderer as='div' columns={gridData.columns} {...props} />
      default:
        return <CellRenderer as='td' columns={gridData.columns} {...props} />
    }
  }
  const scrollTop = () => {
    let o = document.getElementsByClassName("data-grid-container")[0];
    o.scrollTop = 0;
  }
  const clearRows = () => {
    const grid = emptyData(0)
    setGridData({ ...gridData, allRows: grid, grid, selections, currentStart: 0, gridSelections: getSelections(0) })
    scrollTop()
  }
  const removeRows = (e) => {
    let grid = gridData.allRows
    let selections = gridData.selections
    let gridSelections = gridData.gridSelections
    let i = 0
    let removedRows = 0;
    while (i < gridSelections.length) {
      if (gridSelections[i] === true) {
        gridSelections.splice(i, 1)
        removedRows++;
      }
      else {
        i++
      }
    }
    //Since both indices are not same
    let j = 0;
    while (j < selections.length) {
      if (selections[j] === true) {
        grid.splice(j, 1)
        selections.splice(j, 1)
      }
      else {
        j++
      }
    }
    let gridRows = []
    let currentStart = gridData.currentStart
    if (grid.length <= 0) {
      grid = emptyData(0)
      selections = getSelections(0)
      gridSelections = getSelections(0)
      gridRows = grid
      currentStart = 0
      scrollTop()
    }
    else {
      currentStart = currentStart - removedRows - adjustmentCount <= 0 ? 0 : currentStart - removedRows - adjustmentCount
      if (grid.length <= maxNumRows) {
        currentStart = 0
        let gridLength = grid.length
        grid = grid.concat(emptyData(grid.length))
        selections = selections.concat(getSelections(gridLength))
        gridSelections = selections.concat(getSelections(gridLength))
        gridRows = grid
      }
      else if (grid.length > maxNumRows) {        
        const remainder = grid.length % 20
        grid = grid.concat(emptyData(remainder))
        selections = selections.concat(getSelections(remainder))
        currentStart=currentStart-numberOfRows<0?0:currentStart-numberOfRows        
        if(currentStart>=grid.length){
          currentStart=0
        }
        gridRows = grid.slice(currentStart, currentStart + numberOfRows + adjustmentCount)
        gridSelections = selections.slice(currentStart, currentStart + numberOfRows + adjustmentCount)
      }
    }
    scrollTop()
    setGridData({ ...gridData, allRows: grid, grid: gridRows, selections, currentStart, gridSelections })
  }
  const addNewRow = () => {
    const grid = gridData.allRows
    const selections = gridData.selections
    grid.push(getEmptyArray())
    selections.push(false)
    let currentRows = gridData.grid
    let gridSelections = gridData.gridSelections
    if (gridData.grid.length <= numberOfRows) {
      currentRows = gridData.allRows.slice(gridData.currentStart, gridData.currentStart + numberOfRows)
      gridSelections = gridData.selections.slice(gridData.currentStart, gridData.currentStart + numberOfRows)
    }
    setGridData({ ...gridData, allRows: grid, grid: currentRows, selections, gridSelections })
  }
  const redirectBackToPreviousPage = () => {
    history.goBack()
  }
  function validateInput(data) {
    let count = 0
    for (let j = 0; j < data.length; j++) {
      if (data[j].value === '') {
        count++
      }
      if (j === 5 && (data[5].value === 0 || data[5].value === '')) {
        count++
      }
    }
    if (count > data.length) {
      return true
    }
    return false
  }
  function doCheckEmptyRows(e) {
    let emptyCompanyCount = 0
    for (let i = 0; i < gridData.grid.length; i++) {
      const data = gridData.grid[i]
      if (validateInput(data)) {
        emptyCompanyCount++
      }
    }
    if (emptyCompanyCount >= gridData.grid.length) {
      setIsEmptyDialogVisible(true)
    } else {
      setIsDialogVisible(true)
    }
  }

  function submitData(e) {
    const uuId = uuidv4()
    const timestamp = new Date()
    const companyList = []
    for (let i = 0; i < gridData.allRows.length; i++) {
      const data = gridData.allRows[i]
      if (validateInput(data)) {
        continue
      }
      const company = {
        uniqueId: uuId,
        name: data[0].value,
        ticker: data[1].value,
        sectorName: data[2].value,
        industryName: data[3].value,
        exchangeName: (data[4].value === '' ? null : data[4].value),
        marketCapitalization: companyValidation.checkMarketCap(data[5].value.toString().replace(',', '')),
        exchangeCountry: data[6].value,
        earningsYeild: data[7].value,
        barriers: data[8].value,
        financialStrength: data[9].value,
        momentum: data[10].value,
        growthType: data[11].value,
        topNewsBuy: data[12].value,
        dividendLeader: data[13].value,
        sociallyResponsible: data[14].value,
        watchlist: data[15].value,
        intersection: data[16].value,
        underValued: data[17].value,
        createdBy: currentUserId,
        createdOn: timestamp
      }
      companyList.push(company)
    }
    if (companyList.length > 0) {
      setshowLoader(true)
      bulkAddForCopyPaste(companyList, uuId)
    }
  }
  const footer = (
    <div>
      <Button label="OK" icon="pi pi-check" onClick={(e) => { setIsDialogVisible(false); submitData(e) }} />
      <Button label="Cancel" className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => setIsDialogVisible(false)} />
    </div>
  )

  const footerEmpty = (
    <div>
      <Button label="Close" className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => setIsEmptyDialogVisible(false)} />
    </div>
  )
  const tableScroll = (e) => {
    let o = document.getElementsByClassName("data-grid-container")[0];
    const offsetValue = o.offsetHeight / 2
    if (o.scrollTop !== 0 && o.clientHeight + o.scrollTop >= (o.scrollHeight - (o.offsetHeight)) + o.clientHeight && gridData.allRows.length > maxNumRows) {
      console.log("Start>>>" + gridData.currentStart + " - " + (gridData.currentStart + numberOfRows))
      let currentStart = gridData.currentStart + numberOfRows;
      if (currentStart < gridData.allRows.length - adjustmentCount) {
        let start = currentStart - adjustmentCount < 0 ? 0 : currentStart - adjustmentCount
        let end = currentStart + numberOfRows + adjustmentCount
        let grid = gridData.allRows.slice(start, end)
        let gridSelections = gridData.selections.slice(start, end)
        setGridData({ ...gridData, grid, currentStart, scrollTop: o.scrollTop, gridSelections })
        o.scrollTop = (o.scrollTop - o.offsetHeight / 2 <= 0) ? 10 : (o.scrollTop - offsetValue)
        console.log(">>>" + o.scrollTop)
      }/* else {
        currentStart = gridData.allRows.length - adjustmentCount - numberOfRows
        setGridData({ ...gridData, currentStart, scrollTop: o.scrollTop })
        o.scrollTop = (o.scrollTop - o.offsetHeight/2 <= 0) ? 10 : (o.scrollTop - offsetValue)
        console.log("<<<" + o.scrollTop)
      }*/
    }
    else if (o.scrollTop >= 0 && o.scrollTop <= 20 && gridData.currentStart > 0) {
      console.log("Start>>>" + gridData.currentStart + " - " + (gridData.currentStart + numberOfRows))
      let currentStart = gridData.currentStart - numberOfRows
      if (currentStart < 0) {
        currentStart = 0
      }
      if (currentStart >= 0) {
        let start = currentStart - adjustmentCount < 0 ? 0 : currentStart - adjustmentCount
        let end = currentStart + numberOfRows + adjustmentCount
        const grid = gridData.allRows.slice(start, end)
        let gridSelections = gridData.selections.slice(start, end)
        setGridData({ ...gridData, grid, currentStart, scrollTop: o.scrollTop, gridSelections })
        o.scrollTop = o.scrollTop + offsetValue
      }
    }
    //console.log(o.scrollTop)
  }
  return (<div className="tableScrollFixParent">
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <div className="p-col-12 titleSec">
            <img src={back} alt={back} className="m-r-10 pointer" onClick={() => redirectBackToPreviousPage()} />
            <h4 className="display_1 m-b-0">Copy & Paste Data</h4>
          </div>
          {gridData.grid.length > 0 && <div className="p-col flex p-justify-end">
            <Button className="p-button-raised p-button-rounded inputHolder--formBtn m-r-10" label="Remove Selected" onClick={(e) => removeRows(e)} />
            <Button className="p-button-raised p-button-rounded inputHolder--formBtn m-r-10" label="Clear All" onClick={(e) => clearRows(e)} />
            <Button className="p-button-raised p-button-rounded inputHolder--formBtn" label="Add New Row" onClick={(e) => addNewRow(e)} />
          </div>
          }
          <div className="tableScrollFix" onScroll={tableScroll} id="table_div">
            <ReactDataSheet
              data={gridData.grid}
              className='custom-sheet'
              sheetRenderer={sheetRenderer}
              rowRenderer={rowRenderer}
              cellRenderer={cellRenderer}
              onCellsChanged={handleCellsChanged}
              valueRenderer={(cell) => cell.value}
            />
          </div>
          {gridData.grid.length > 0 ?
            <div className="p-col flex p-justify-end">
              <Button className="p-button-raised p-button-rounded inputHolder--formBtn" label="Submit" onClick={(e) => doCheckEmptyRows(e)} />
            </div> : ''
          }
          <div className="p-col-12 m-t-10 m-b-8 divTextCenter">
            {showResult &&
              <div>
                <div className="m-b-10 green-bg">Added : {uploadDataReponse.saved}</div>
                <div className="m-b-10 yellow-bg">Updated : {uploadDataReponse.updated}</div>
                <div className="m-b-10 red-bg">Failed : {uploadDataReponse.failed}</div>
                <div>Duplicate : {uploadDataReponse.duplicate}</div>
              </div>
            }
          </div>
          <div>
            <Dialog header="Import Data" footer={footer} visible={isDialogVisible} style={{ width: '50vw' }} modal={true} onHide={() => setIsDialogVisible(false)}>
              <div>Please review the order of pasted fields. If the order is not matching with the order given here, click cancel and rearrange the pasted data or click Ok to submit</div>
            </Dialog>

            <Dialog header="Import Data" footer={footerEmpty} visible={isEmptyDialogVisible} style={{ width: '50vw' }} modal={true} onHide={() => setIsEmptyDialogVisible(false)}>
              <div>There is no data to import</div>
            </Dialog>
          </div>
        </Card>
      </div>
      {showLoader && <div className="overlay">
        <div className="lds-ripple"><div></div><div></div></div>
      </div>}
    </div>
  </div>)
}
BulkCopyComponent.propTypes = {
  bulkAddForCopyPaste: PropTypes.func,
  bulkUpdatResponse: PropTypes.object
}
export default BulkCopyComponent
